export default __webpack_public_path__ + "static/media/messageAlert16.77777982.svg";